import { render, staticRenderFns } from "./SelectAssets.vue?vue&type=template&id=7b84fb0d&scoped=true&"
import script from "./SelectAssets.vue?vue&type=script&lang=js&"
export * from "./SelectAssets.vue?vue&type=script&lang=js&"
import style0 from "./SelectAssets.vue?vue&type=style&index=0&id=7b84fb0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b84fb0d",
  null
  
)

export default component.exports